module.exports = __webpack_public_path__ + "img/contact us copy.11c69894.svg";